import { createTheme, ThemeOptions } from "@mui/material/styles"
import themeComponents from "./theme-components"

const colors = {
  primaryMain: "#0F172A",
  primaryContrastText: "#ffffff",
  secondaryMain: "#E2E8F0",
  secondaryContrastText: "#0F172A",
  errorMain: "#FA897B",
  successMain: "#B6E3CE",
  warningMain: "#FFDD94",
  infoMain: "#A8D8F0",
  textPrimary: "#0F172A",
  textSecondary: "#B3B3B3",
  textDisabled: "#9CA3AF",
  divider: "#f0f0f0",
  backgroundDefault: "#ffffff",
  actionHover: "#E2E8F0",
  actionSelected: "#F1F5F9",
  sidebarMain: "#334155",
  sidebarContrastText: "#334155",
  tableFontSize: "0.875rem",
  borderColor: "#f0f0f0",
  loadingDot: "#000000",
  tableHeaderBgColor: "#f3f3f3",
  inputBoxBgColor: "#FAFAFA",
  inputLabelColor: "#0F172A",
  inputPlaceHolderColor: "#999999"
}

const lightTheme: ThemeOptions = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: colors.primaryMain,
      contrastText: colors.primaryContrastText
    },
    secondary: {
      main: colors.secondaryMain,
      contrastText: colors.secondaryContrastText
    },
    error: {
      main: colors.errorMain
    },
    success: {
      main: colors.successMain,
      contrastText: colors.primaryMain
    },
    info: {
      main: colors.infoMain,
      contrastText: colors.primaryMain
    },
    warning: {
      main: colors.warningMain
    },
    background: {
      default: colors.backgroundDefault,
      paper: colors.backgroundDefault
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
      disabled: colors.textDisabled
    },
    divider: colors.divider,
    action: {
      hover: colors.actionHover,
      selected: colors.actionSelected
    },
    neutral: {
      light: colors.backgroundDefault,
      dark: colors.secondaryContrastText,
      main: colors.secondaryMain,
      contrastText: colors.primaryContrastText
    },
    grey: {
      500: colors.secondaryContrastText
    },
    sidebar: {
      main: colors.sidebarMain,
      contrastText: colors.sidebarContrastText,
      hover: colors.actionSelected,
      submenuBackground: colors.secondaryMain,
      active: colors.actionSelected
    },
    table: {
      headerColor: colors.secondaryContrastText,
      headerBackground: colors.tableHeaderBgColor,
      color: colors.primaryMain,
      background: colors.secondaryMain,
      active: colors.actionSelected,
      border: colors.borderColor,
      fontSize: colors.tableFontSize
    },
    scrollbar: {
      thumb: colors.secondaryContrastText,
      track: colors.secondaryMain
    },
    input: {
      boxBgColor: colors.inputBoxBgColor,
      labelColor: colors.inputLabelColor,
      placeholderColor: colors.inputPlaceHolderColor
    } as any
  },
  typography: {
    fontFamily: `'Poppins',"Lato", "Inter",Roboto, sans-serif`,
    h1: { fontSize: "1.54rem", fontWeight: 700, lineHeight: 1.5 },
    h2: { fontSize: "1.32rem", fontWeight: 600, lineHeight: 1.4 },
    h3: { fontSize: "1.1rem", fontWeight: 600, lineHeight: 1.3 },
    h4: { fontSize: "1.01rem", fontWeight: 600, lineHeight: 1.3 },
    h5: { fontSize: "0.88rem", fontWeight: 600, lineHeight: 1.3 },
    body1: { fontSize: "0.88rem", fontWeight: 400, lineHeight: 1.5 },
    body2: { fontSize: "0.77rem", fontWeight: 400, lineHeight: 1.4 },
    subtitle1: { fontSize: "0.66rem", fontWeight: 400, lineHeight: 1.3 },
    subtitle2: { fontSize: "0.55rem", fontWeight: 400, lineHeight: 1.2 },
    caption: { fontSize: "0.55rem", fontWeight: 400, lineHeight: 1.1 }
  },
  components: themeComponents
})

export default lightTheme
